// src/hooks/internal/useDataRef.ts
import { useRef } from "react";
var useDataRef = (data) => {
  const ref = useRef(data);
  ref.current = data;
  return ref;
};
export {
  useDataRef
};
//# sourceMappingURL=useDataRef.js.map